import { render, staticRenderFns } from "./AppScoresNFL.vue?vue&type=template&id=33815e80&"
import script from "./AppScoresNFL.vue?vue&type=script&lang=js&"
export * from "./AppScoresNFL.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports